const DefaultVariant = require('./default')
const LandscapeVariant = require('./landscape')
const LinkBreakerVariant = require('./link-breaker')
const LinkHighlightVariant = require('./link-highlight')
const CardListVariant = require('./card-list')
const MastheadPrimaryVariant = require('./masthead-primary')
const MastheadCarouselVariant = require('./masthead-carousel')
const SidebarBackgroundVariant = require('./sidebar-background')
const CallToBookVariant = require('./call-to-book')
const RoomOverviewVariant = require('./room-overview')
const JoinFansVariant = require('./join-fans')
const RateDetailsVariant = require('./rate-details')
const ExperienceListVariant = require('./experience-list')
const MenuListVariant = require('./menu-list')
const ProposalBanner = require('./proposal-banner')
const UpcomingEvents = require('./upcoming-events')
const ResortCard = require('./resort-card')
const FansDashboard = require('./fans-dashboard')
const FcContactUs = require('./fc-contact-us')

const lazyload = {
  [DefaultVariant.name]: DefaultVariant,
  [LandscapeVariant.name]: LandscapeVariant,
  [LinkBreakerVariant.name]: LinkBreakerVariant,
  [LinkHighlightVariant.name]: LinkHighlightVariant,
  [LinkHighlightVariant.name]: LinkHighlightVariant,
  [CardListVariant.name]: CardListVariant,
  [MastheadCarouselVariant.name]: MastheadCarouselVariant,
  [MastheadPrimaryVariant.name]: MastheadPrimaryVariant,
  [SidebarBackgroundVariant.name]: SidebarBackgroundVariant,
  [CallToBookVariant.name]: CallToBookVariant,
  [RoomOverviewVariant.name]: RoomOverviewVariant,
  [JoinFansVariant.name]: JoinFansVariant,
  [RateDetailsVariant.name]: RateDetailsVariant,
  [ExperienceListVariant.name]: ExperienceListVariant,
  [MenuListVariant.name]: MenuListVariant,
  [ProposalBanner.name]: ProposalBanner,
  [UpcomingEvents.name]: UpcomingEvents,
  [ResortCard.name]: ResortCard,
  [FansDashboard.name]: FansDashboard,
  [FcContactUs.name]: FcContactUs
}

module.exports = {
  lazyload
}
